import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { RbacServiceInterface } from '../rbac-service.interface';

@DestroySubscribers()
@Injectable()
export class CanGuard {
  private can: boolean;

  constructor(private router: Router, @Inject('RbacServiceInterface') private rbacService: RbacServiceInterface) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const data = route.data;
    if (data.middleware) {
      /**
       * At least one ok
       */
      if (data.middleware.permissions) {
        this.can = this.rbacService.can(data.middleware.permissions);
        if (this.can) {
          return true;
        } else {
          this.router.navigate(['app/dashboard']);
          return false;
        }
      }
    }
    return false;
  }
}
